import { resolveSaveUserErrorParams, SaveUserError } from "@robe/core-api/errors";
import { User } from "@robe/core-types/user";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

/**
 * @throws {SaveUserError}
 */
export const saveUser =
  (method: "PUT" | "POST") =>
    (user: User | (Partial<User> & Omit<User, "id">), core: XcoreCore): BaseApiRequest<User> =>
      core
        .fetch("/api/user", {
          method,
          body: JSON.stringify(user),
        })
        .then((res) => res.json())
        .catch((err) => {
          const saveUserError = resolveSaveUserErrorParams(err);
          if (saveUserError) {
            throw new SaveUserError(saveUserError);
          }

          throw err;
        });

/**
 * @throws {SaveUserError}
 */
export const insertUser = saveUser("POST");

/**
 * @throws {SaveUserError}
 */
export const updateUser = saveUser("PUT");
